// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12d16b9e","455":"dcb724e7"}[chunkId] + ".chunk.js";
};